var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconConfig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  var unique = Math.random().toString(36).substring(2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.1,
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.065 8.898a.542.542 0 00-.318.104l-.065.055L3.3 11.44a3.937 3.937 0 000 5.56 3.916 3.916 0 002.559 1.145l.22.006.223-.006a3.916 3.916 0 002.395-.99L8.861 17l2.382-2.382a.543.543 0 00-.692-.83l-.075.063-2.382 2.382a2.852 2.852 0 01-4.028 0 2.852 2.852 0 01-.123-3.896l.123-.131L6.45 9.824a.542.542 0 00-.384-.926zm5.526-5.742l-.151.144L9.1 5.639a.543.543 0 00.702.822l.065-.055 2.34-2.34a2.85 2.85 0 014.026 0 2.85 2.85 0 01.124 3.897l-.124.13-2.339 2.34a.542.542 0 00.299.919l.084.006.086-.006a.54.54 0 00.233-.097l.065-.055 2.34-2.34a3.938 3.938 0 000-5.56 3.94 3.94 0 00-5.253-.278l-.157.134z",
    stroke: "#191C26",
    fill: "#191C26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.342 12.56a.601.601 0 01-.426-1.028l3.616-3.616a.602.602 0 11.852.852l-3.616 3.616a.6.6 0 01-.426.177",
    stroke: "#3B65EE",
    fill: "#3B65EE"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConfig);
export default __webpack_public_path__ + "static/assets/icon-config.0e08660b.svg";
export { ForwardRef as ReactComponent };